// extracted by mini-css-extract-plugin
export default {"default":"List__default--yic99","checkmarks":"List__checkmarks--GG3mL List__default--yic99","sm":"List__sm--H4fnQ"};